<template>
  <div>
    <div class="bk-blue secret-blue">
      <div class="container">
        <h2><span>Secretul 2<br></span>Laptele de <br class="d-block d-md-none">mamă conține aproximativ 200 <br> de structuri de oligozaharide</h2>
        <p>Cercetarea oligozaharidelor din laptele matern a început încă din anii ’30, dar varietatea și unicitatea
          laptelui matern fac din oligozaharide un subiect de continuă preocupare pentru oamenii de știintă. Se
          știe despre oligozaharidele din laptele matern că fiecare dintre ele îndeplinește un rol specific.
        </p>
      </div>
    </div>
    <div class="secret-white">
      <div class="container secret-container">
        <div class="row">
          <div class="secret--container-quote col-2">
            <img src="../../assets/images/image-secretele-laptelui/quote.png" alt="/">
          </div>
          <div class="secret--container-content col-10">
            <p>„Aproximativ 200 de structuri cunoscute de oligozaharide din laptele matern contribuie la
              dezvoltarea sistemului imunitar al bebelușului prin intermediul florei intestinale”
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {}
  },
}
</script>
<style scoped lang="scss">

</style>
